import React from 'react';
import { MAX_ITEM_NOTES_LENGTH } from '../../state/cart/cartTypes';

type CartItemNotesFieldProps = {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  className?: string;
};

export function CartItemNotesField({ value, onChange, id, className = '' }: CartItemNotesFieldProps) {
  return (
    <textarea
      id={id}
      className={`form-control form-control-sm chunkzters-input ${className}`.trim()}
      rows={2}
      maxLength={MAX_ITEM_NOTES_LENGTH}
      placeholder="Add notes (e.g. no mayo, no ketchup)"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export function ItemLineExtras({
  drinkName,
  notes,
  isMeal,
  saladSauceLabel,
  flavourChoiceLabel,
}: {
  drinkName?: string;
  notes?: string;
  isMeal?: boolean;
  saladSauceLabel?: string;
  flavourChoiceLabel?: string;
}) {
  if (!drinkName && !notes && !isMeal && !saladSauceLabel && !flavourChoiceLabel) return null;
  return (
    <ul className="small mb-0 ps-3 mt-1" style={{ color: 'var(--chunkzters-muted)' }}>
      {isMeal ? <li>Make it a meal</li> : null}
      {flavourChoiceLabel ? <li>Flavour: {flavourChoiceLabel}</li> : null}
      {saladSauceLabel ? <li>{saladSauceLabel}</li> : null}
      {drinkName ? <li>Option: {drinkName}</li> : null}
      {notes ? <li>Notes: {notes}</li> : null}
    </ul>
  );
}
